import Api from '~/api'
import { Map, List, fromJS } from 'immutable'
import { serializeFilters } from '../datatable'

export function getNote(entity, entity_id, type) {
  return async (dispatch, getState) => {
    try {
      if (!getState().notes.has(`${entity}.${entity_id}.${type}`))
        dispatch({
          type: 'NOTE_LOADING',
          entity,
          entity_id,
          noteType: type,
          loading: true,
        })

      let { data } = await Api.get(`/note/${entity}/${entity_id}/${type}`)

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'NOTE_SUCCESS',
        entity,
        entity_id,
        noteType: type,
        note: data.note,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'NOTE_ERROR',
        entity,
        entity_id,
        noteType: type,
        message: err.message || 'Error when getting log',
      })
    }
  }
}

export function saveNote(entity, entity_id, type, content, relatedInterview = false) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'NOTE_LOADING',
        entity,
        entity_id,
        noteType: type,
        loading: true,
      })

      let { data } = await Api.post(`/note/${entity}/${entity_id}/${type}`, { content, relatedInterview })

      if (!data.success) throw Error(data.message)

      dispatch({
        type: 'NOTE_SUCCESS',
        entity,
        entity_id,
        noteType: type,
        note: data.note,
        open: false,
      })
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'NOTE_ERROR',
        entity,
        entity_id,
        noteType: type,
        message: err.message || 'Error when getting log',
        open: false,
      })
    }
  }
}
